import { Capacitor } from '@capacitor/core';
import { AppUpdate, AppUpdateAvailability } from '@capawesome/capacitor-app-update';

const doImmediateUpdate = async () => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  const result = await AppUpdate.getAppUpdateInfo();

  // updateAvailability 2 = UPDATE_AVAILABLE
  if (result.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE) {
    try {
      await AppUpdate.performImmediateUpdate();
      // O app irá reiniciar automaticamente se for bem-sucedido
    } catch (error) {
      console.error("Erro na atualização ou usuário cancelou", error);
    }
  }
};

export {
  doImmediateUpdate
}
export default doImmediateUpdate;
